class PageableRequest {
  constructor(
      public readonly page: number,
      public readonly perPage: number,
      public readonly sortBy?: string) {
  }
}

export default PageableRequest;